import React, { useEffect } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { useParams } from 'react-router-dom';
import packageJson from '../../../../package.json';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useAppDispatch, useAppSelector } from '../../../app/store/store';
import { selectCurrentPrice, fetchPriceById } from '../../../entities/price/model';

const pdfjsVersion = packageJson.dependencies['pdfjs-dist'].replace(/\^/g, '');

const PriceView = () => {
  const { id } = useParams()
  const price = useAppSelector(selectCurrentPrice)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if(id) {
      dispatch(fetchPriceById(Number(id)))
    }
  }, [id, dispatch])
  return (
    <div>
      <div className="w-full min-h-screen">
        {price && price.file && (
          <Worker
            workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsVersion}/pdf.worker.min.js`}
          >
            <Viewer fileUrl={price.file} />
          </Worker>
        )}
      </div>
    </div>
  );
};

export default PriceView;
